<template>
<v-card dark>
  <v-toolbar color="#4A76A8" height="42">
  <v-toolbar-title class="white--text">
 логи задания
  </v-toolbar-title>
    <v-spacer></v-spacer>

    <v-btn small class="white--text" color="#C46B19" @click="tasks.modals.logs = false">
<v-icon left >mdi-close</v-icon>
 закрыть логи
</v-btn>
  </v-toolbar>
<v-card-text>
  <taskPages    :tasks='tasks'> </taskPages>


<v-layout wrap>

<v-flex>
<v-card style="width: 650px" light>
    <v-card-title> <v-icon color="green" large>mdi-worker</v-icon>  <h2 style="color:#707070; margin-left:14px">Список последних действий</h2>
  <v-spacer></v-spacer>
  <v-btn class="white--text" small color="red"><v-icon left>mdi-delete-sweep</v-icon>Очистить логи</v-btn>
    </v-card-title>
    <v-divider></v-divider>
  <v-card-text>
    статс авмампа амцтгмтац
    ацмщтавгмшгацв авцмштгавцмтгавцм
    авцмшавцтмгтавгм авцмшгтавгшцмташвц авцмташвцшмгтва
    ацвмтшоавцшмтав авцмтавцшомтавшомовац
  </v-card-text>
</v-card>


</v-flex>
<div style="width:15px"></div>

<v-flex  >
<v-card light style="width: 650px">
  <v-card-title> <v-icon color="green" large>mdi-information</v-icon>  <h2 style="color:#707070; margin-left:14px">Общая статистика задания</h2>
  <v-spacer></v-spacer>
  <v-btn class="white--text" small color="red"><v-icon left>mdi-delete-sweep</v-icon>Обнулить статистику</v-btn>
  </v-card-title>
  <v-divider></v-divider>
  <v-card-text>

   <v-layout>
<v-flex>
  Сообщений отправлено : 590
</v-flex>

<v-flex>
  Заявок в друзья отправлено : 590
</v-flex>

   </v-layout>



   <v-layout>
<v-flex>
  Дайков добавлено : 590
</v-flex>

<v-flex>
  Удалили из друзей : 590
</v-flex>

   </v-layout>




      <v-layout>
   <v-flex>
     Сообщений отправлено : 590
   </v-flex>

   <v-flex>
     Зая ено : 590
   </v-flex>

      </v-layout>



  </v-card-text>
</v-card>


</v-flex>

<div>


  </div>







</v-layout>










</v-card-text>


</v-card>






</template>




<script>
import axios from 'axios'
import taskPages from './taskPages.vue'
 export default {
   components:{taskPages },
   props:['tasks'],
     data () {
       return {



       }
     },
 methods : {

 },

 }
</script>





<style>

</style>
